import axios from "axios";

import { LMS_BASE_URL } from "../../../../utils/http/http-common";

import { LMS_TOKEN } from "../../../../utils/cookiesmanager";

import { getLMSData } from "../../../../utils/getLMSData";

export const getPostChapterAssessmentQuestionApiCall = async (args) => {
    const {courseId, moduleId , chapterId  , languageid = 1} = args;

    const authToken = localStorage.getItem(LMS_TOKEN);

    try {
    const response = await axios.get(
      `${LMS_BASE_URL}/course/chapter/post-assessment-questions?courseId=${courseId}&moduleId=${moduleId}&chapterId=${chapterId}&languageId=${languageid}`,{
        headers:{
            Authorization:`Bearer ${authToken}`
        }
      }
    );
    return response;
  } catch (error) {
    const {response} = error || {};
        
    if(response?.data?.statusCode  === 401){
        getLMSData();
    }
    return error.config.data;
  }
};

export const savePostChapterAssessment = async (payload) => {
    const authToken = localStorage.getItem(LMS_TOKEN);

    try {
    const response = await axios.post(
      `${LMS_BASE_URL}/course/chapter/post-assessment`, payload ,{
        headers:{
            Authorization:`Bearer ${authToken}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.config.data;
  }
};